<template>
  <div class="supplyChain">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header class="hidden-xs hidden-sm" :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo" class="hidden-xs"></v-publicBanner>
    <v-recruitmentBanner :bannerInfo="bannerInfoMobile" class="hidden-sm hidden-md hidden-lg"></v-recruitmentBanner>
    <div class="supplyChainCon">
      <div class="supplyContent clearfix">
        <ul class="nav nav-stacked pull-left supplyChainTab" role="tablist">
          <li role="presentation" class="active"><a href="#closedLoop" aria-controls="home" role="tab" data-toggle="tab" @click="selectTab('采购平台')">流程闭环</a></li>
          <li role="presentation"><a href="#systemDocking" aria-controls="profile" role="tab" data-toggle="tab" @click="selectTab('中台系统')">系统对接</a></li>
          <li role="presentation"><a href="#richSource" aria-controls="messages" role="tab" data-toggle="tab" @click="selectTab('协同平台')">丰富寻源</a></li>
          <li role="presentation"><a href="#analysis" aria-controls="settings" role="tab" data-toggle="tab" @click="selectTab('BI平台')">统计分析</a></li>
          <li role="presentation"><a href="#mobile" aria-controls="settings" role="tab" data-toggle="tab" @click="selectTab('移动端')">移动端</a></li>
          <li role="presentation"><a href="#creditReporting" aria-controls="settings" role="tab" data-toggle="tab" @click="selectTab('征信系统')">企业征信</a></li>
        </ul>
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane active" id="closedLoop">
            <h4><span class="tabLine"></span>从申请到履约全采购流程闭环</h4>
            <div class="tabPaneCon">
              <p>采购计划与需求管理</p>
              <p>采购订单全流程及特殊审批</p>
              <p>收发货流程</p>
              <p>供应商及物料数据管理</p>
              <button type="button" class="btn btn-default btn-lg"  @click="openDialog()">立即体验</button>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="systemDocking">
            <h4><span class="tabLine"></span>与企业现有系统无缝对接</h4>
            <div class="tabPaneCon">
              <p>与OA、ERP等内部系统对接</p>
              <p>一链网所有产品单点登录</p>
              <p>多组织多层级的角色权限管理</p>
              <button type="button" class="btn btn-default btn-lg" @click="openDialog()">立即体验</button>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="richSource">
            <h4><span class="tabLine"></span>拓展寻源渠道，提升寻源效率</h4>
            <div class="tabPaneCon">
              <p>商城式目录采购</p>
              <p>外部资源对接</p>
              <p>线上竞价、市场比价、历史比价</p>
              <button type="button" class="btn btn-default btn-lg" @click="openDialog()">立即体验</button>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="analysis">
            <h4><span class="tabLine"></span>统计分析</h4>
            <div class="tabPaneCon">
              <p>采购业务数据分析</p>
              <p>供应商数据分析</p>
              <p>成本节约分析</p>
              <p>流程效率分析</p>
              <button type="button" class="btn btn-default btn-lg" @click="openDialog()">立即体验</button>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="mobile">
            <h4><span class="tabLine"></span>办公移动化</h4>
            <div class="tabPaneCon">
              <p>订单快捷操作</p>
              <p>消息/待办推送</p>
              <p>移动端审批</p>
              <button type="button" class="btn btn-default btn-lg" @click="openDialog()">立即体验</button>
            </div>
          </div>
          <div role="tabpanel" class="tab-pane" id="creditReporting">
            <h4><span class="tabLine"></span>供应商管理及风控体系</h4>
            <div class="tabPaneCon">
              <p>订单履约评价</p>
              <p>物流服务评价</p>
              <p>平台指标参考</p>
              <p>履约风险预警</p>
              <button type="button" class="btn btn-default btn-lg" @click="centerDialogVisible = true">立即体验</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="valueRealization">
      <v-publiceTit :titleObj="titleObj"></v-publiceTit>
      <v-realizationPublic :realizationInfo="realizationInfo"></v-realizationPublic>
    </div>
    <v-footer :webConfigInfo='webConfigInfo'  :footerColumnInfos='footerColumnInfos'></v-footer>
    <el-dialog
      title=""
      custom-class="experienceDialog"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <p class="hotline">如需更好的了解一链采购供应链数智化系统，寻求更多采购供应链解决方案，入驻成为平台采购商，请您填写以下信息，或拨打免费服务热线：<span>0516-87796393</span></p>
      <el-form :model="ruleForm" :rules="rules" ref="recruitForm" label-width="92px" class="demo-ruleForm">
        <!--<el-form-item label="角色" prop="roleName">-->
          <!--<el-select v-model="ruleForm.roleName" placeholder="请输入角色">-->
            <!--<el-option-->
              <!--v-for="item in options"-->
              <!--:key="item.value"-->
              <!--:label="item.label"-->
              <!--:value="item.value">-->
            <!--</el-option>-->
          <!--</el-select>-->
        <!--</el-form-item>-->
<!--        <el-form-item label="角色" prop="roleName">-->
<!--          <el-radio-group v-model="ruleForm.roleName">-->
<!--            <el-radio v-for="item in options" :label="item.value" :key="item.value">{{item.label}}</el-radio>-->
<!--          </el-radio-group>-->
<!--        </el-form-item>-->
        <el-form-item label="姓名" prop="userName">
          <el-input v-model="ruleForm.userName" placeholder="请输入姓名"  :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="职位" prop="positionName">
          <el-input v-model="ruleForm.positionName" placeholder="请输入职位"  :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contractPhone">
          <el-input v-model="ruleForm.contractPhone" placeholder="请输入联系电话"  :maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="ruleForm.companyName" placeholder="请输入公司名称"  :maxlength="50"></el-input>
        </el-form-item>
<!--        <el-form-item label="试用平台" prop="trialPlatform">-->
<!--          <el-checkbox-group v-model="ruleForm.trialPlatform" @change="handleChange">-->
<!--            <el-checkbox label="采招平台" ></el-checkbox>-->
<!--            <el-checkbox label="协同平台" ></el-checkbox>-->
<!--            <el-checkbox label="供应商管理" ></el-checkbox>-->
<!--            <el-checkbox label="征信产品" ></el-checkbox>-->
<!--          </el-checkbox-group>-->
<!--        </el-form-item>-->
        <div class="clearfix">
          <div class="trialPlatform-label pull-left">
            <i style="color: #f56c6c;">*</i>
            我的需求
            <el-tooltip class="item" effect="dark" content="贵公司希望通过一链网，解决当前采购遇到的哪些问题？" placement="top">
              <el-button type="text" style="vertical-align: middle;">
                <i class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </div>
          <div class="pull-left trialPlatform-item" style="width: 300px;font-size: 12px">
            <el-form-item label-width="0" prop="trialPlatform">
              <el-input v-model="ruleForm.trialPlatform"
                        style="font-size: 12px;"
                        type="textarea"
                        :maxlength="100"
                        :show-word-limit="true"
                        placeholder="如 电子招标、供应商管理、合同管理"
                        :autosize="{ minRows: 2, maxRows: 6 }"></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">提交</el-button>
      </div>
    </el-dialog>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
  import header from '@/components/v-header/header'
  import topBar from '@/components/topBar'
  import publicBanner from '@/components/publicBanner'
  import recruitmentBanner from '@/components/recruitmentBanner'
  import publiceTit from '@/components/publiceTit'
  import realizationPublic from '@/components/realizationPublic'
  import footer from '@/components/v-footer'
  import backToTop from '@/components/backToTop'
  export default {
    props: [],
    data () {
       var checkMobile = (rule, value, callback) => {
        var reg=/^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        var isMob=  /^0\d{2,3}-?\d{7,8}$/;// 座机格式
        if (!reg.test(value)&&!isMob.test(value)) {
          return callback(new Error('请输入有效的联系电话'));
        }else{
          return callback();
        }
      };
      return {
        options: [{
          value: '0',
          label: '采购商'
        }, {
          value: '1',
          label: '供应商'
        }],
        hitSearchUrl:'',
        enterpriseResourceBaseUrl:'',
        yellowPageColumn:{},
        productAndSolutionColumn:{},
        navigationColumnInfos: [],
        bannerInfo: {title: '采购供应链',content: "覆盖采购申请发起、采购订单创建，供应商确认订单、发货，采购商收货、入库、履约评价的全流程闭环，提供线上协同作业解决方案，实现 “全业务流程可视化、全采购数据可视化、全操作流程一体化”的采购订单端到端服务"},
        bannerInfoMobile: {name: '采购供应链', eng: 'Purchasing Supply Chain'},
        titleObj: {name: '为您实现', eng: 'Value realization'},
        realizationInfo: [{title: '整合采购资源', content: '提供商城式目录采购，集合本企业供应商、协议等资源，支持商品比价、一键申请，让您的采购发起更便捷。'},{title: '信息实时共享', content: '业务数据在线传递，缩短采供双方信息交互所需时间，量化记录采购周期。在线响应，减少人工操作冗余的沟通，提高采购工作效率。'},{title: '发挥数据价值', content: '记录并留存交易关键数据，提供分析工具及可视化报表，为企业决策提供实时、准确的数据支持，也为供应商培养、评估提供方向。'},{title: '支持系统对接', content: '支持与企业ERP、OA等内部系统对接，打通内部外部供应链，避免重复操作，实现内部需求到外部订单一键转化。'}],
        webConfigInfo: {},
        footerColumnInfos:[],
        messageData: [],
        messageTotal:0,
        currentPage:1,
        centerDialogVisible:false,
        ruleForm: {
          // roleName: '',
          userName: '',
          positionName: '',
          contractPhone: '',
          companyName: '',
          trialPlatform: ''
        },
        checkList:[],
        rules: {
          // roleName: [
          //   { required: true, message: '请选择角色', trigger: 'change' }
          // ],
          userName: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          companyName: [
            { required: true, message: '请输入公司名称', trigger: 'blur' }
          ],
          positionName: [
            { required: true, message: '请输入职位', trigger: 'blur' }
          ],
          contractPhone: [
            { required: true, message: '电话不能为空', trigger: 'blur' },
            { validator: checkMobile, trigger: 'blur' }

          ],
          trialPlatform: [
            { required: true, message: '请输入您的需求', trigger: 'blur' }
          ]
        }

      }
    },
    components: {
      'v-header': header,
      'v-topBar': topBar,
      'v-publicBanner': publicBanner,
      'v-recruitmentBanner': recruitmentBanner,
      'v-publiceTit': publiceTit,
      'v-realizationPublic': realizationPublic,
      'v-footer': footer,
      'v-backToTop': backToTop
    },
    created () {
      this.$axios.post('/onelink.mdata.main.api/mainInfo/findMainCommonInfo', {
      }).then((res) => {
        this.data = res.data;
        this.webConfigInfo = this.data.webConfigInfoDto;
        this.footerColumnInfos = this.data.footerColumnInfos;
        this.navigationColumnInfos = this.data.navigationColumnInfos;
        this.yellowPageColumn = this.data.yellowPageColumn;
        this.productAndSolutionColumn = this.data.productAndSolutionColumn;
        this.hitSearchUrl = this.data.hitSearchUrl;
        this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
      }).catch((err) => {
        console.log(err)
      })
    },
    mounted () {
    },
    methods: {
      submitForm() {
        this.$refs['recruitForm'].validate((valid) => {
          if (valid) {
            this.$axios.post('/onelink.mdata.main.api/task/addTaskInfo', {
              taskSource: 0,
              // roleName: this.ruleForm.roleName,
              userName: this.ruleForm.userName,
              positionName:this.ruleForm.positionName,
              contractPhone: this.ruleForm.contractPhone,
              companyName: this.ruleForm.companyName,
              trialPlatform: this.ruleForm.trialPlatform,
              operateStaus: 0
            }).then((res) => {
              this.data = res.data;
              let operateNumber = this.data.data;
              if(res.data.code == '0'){
                if(this.getToken('isLogin') == ''){

                  if(/Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent)) {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交,请到PC端, <span style="color:red">三分钟快速注册</span></strong>'
                    });
                    return;
                  } else {
                    this.$message({
                      dangerouslyUseHTMLString: true,
                      message: '<strong>试用申请已提交, <a href="/register" style="color:red">三分钟快速注册</a></strong>'
                    });
                    return;
                  }


                }else{
                  this.$message({
                     message: "试用申请已提交",
                     type: 'success'
                 });
                }
                 this.centerDialogVisible = false;
              }else{
                this.$message({
                     message: "试用提交失败!",
                     type: 'error'
                 });
              }
            }).catch((err) => {
              console.log(err)
            })
          } else {
            return false;
          }
        });
      },
      // handleChange(value){
      //   this.ruleForm.trialPlatform = value;
      // },
      selectTab(value){
        // this.ruleForm.trialPlatform = value;
      },
      openDialog(){
        this.centerDialogVisible = true;
        // this.ruleForm.roleName = '';
        this.ruleForm.userName = '';
        this.ruleForm.positionName = '';
        this.ruleForm.contractPhone = '';
        this.ruleForm.companyName = '';
        this.ruleForm.trialPlatform = '';
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/supplyChain/index.vue